<template>
  <div class="row">
    <div class="col-lg-4 col-md-5">
      <collaborator-card :collaborator="collaborator"></collaborator-card>
    </div>
    <div class="col-lg-8 col-md-7">
      <evaluation-card :collaboratorId="collaboratorId"></evaluation-card>
    </div>
    <div class="col-lg-12 col-sm-12" style="text-align:center;margin:20px 0;">
      <router-link to="/avaliacao/equipe">
        <button type="button" class="btn btn-wd btn-default btn-move-left"><span class="btn-label"><i class="ti-angle-left"></i></span>
            Voltar
        </button>
      </router-link>
    </div>
  </div>
</template>
<script>
  import CollaboratorCard from './CollaboratorProfile/CollaboratorCard.vue'
  import EvaluationCard from './CollaboratorProfile/EvaluationCard.vue'
  import swal from 'sweetalert2'

  export default {
    mounted () {
      this.collaboratorId = parseInt(this.$route.params.collaboratorId)
      this.getCollaborator()
    },
    components: {
      CollaboratorCard,
      EvaluationCard
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    created () {
      $('html, body').animate({ scrollTop: 0 }, 600)
    },
    data () {
      return {
        collaboratorId: null,
        collaborator: {}
      }
    },
    methods: {
      getCollaborator () {
        let url = `/collaborator/manager/collaborator/${this.collaboratorId}`
        axios.get(url).then((res) => {
          this.collaborator = res.data
        }).catch(error => {
          let message = 'Não foi possível completa requisição, tente novamente mais tarde.'

          if (error.response.status !== 500) {
            message = error.response.data.error
          }

          swal({
            title: 'Colaborador!',
            text: message,
            type: 'error',
            showCancelButton: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            confirmButtonText: 'Voltar',
            buttonsStyling: false,
            allowOutsideClick: false,
            preConfirm: () => {
              return (new Promise((resolve, reject) => {
                resolve('OK')
              }))
            }
          }).then(() => {
            this.$router.push(`/avaliacao/equipe`)
          }).catch(swal.noop)
        })
      }
    }
  }
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Manager/Evaluation/Team/View.vue